import {ChangeDetectorRef, Component, ElementRef, OnInit} from '@angular/core';
import {AbstractGridColumnComponent} from '../abstract-grid-column.component';
import {ModulesStateService} from '../../../../services/modules-state.service';
import {FormViewerComponent} from '../../../../../form-viewer/form-viewer.component';
import {ChangeDetectorRefHelper} from '../../../../../helpers/change-detector-ref.helper';
import {GenericTurboGridComponent} from '../../../generic-turbo-grid/generic-turbo-grid.component';
import {EntityStatus} from '../../../../../services/entity/entity-status';
import {EntityManagerService} from '../../../../../../core/service/entity-manager/entity-manager.service';

@Component({
  selector: 'app-user-responsible-group-selection-column',
  template: `
    <p-checkbox
      pInputCheckbox
      binary="true"
      (onChange)="onChange($event)"
      [ngModel]="isSelected()"
    ></p-checkbox>
  `
})
export class UserResponsibleGroupSelectionComponent extends AbstractGridColumnComponent implements OnInit {

  protected formComponent: FormViewerComponent = null;
  protected masterComponent: GenericTurboGridComponent = null;

  public constructor(
    public cdr: ChangeDetectorRef,
    protected elementRef: ElementRef,
    protected modulesStateService: ModulesStateService,
    protected entityManager: EntityManagerService
  ) {
    super(elementRef);
  }

  ngOnInit() {
    this.initComponents();
  }

  onChange(event) {
    if (event) {
      this.selectEntity(this.entity, this.node);
    } else {
      this.unSelectEntity(this.entity, this.node);
    }
  }

  private initComponents(): void {
    const components = this.modulesStateService.getCurrent().getComponents();

    let formComponent = null,
      masterComponent = null;

    for (const component of components) {
      if (component instanceof FormViewerComponent) {
        formComponent = component;
      }

      if (component.elementContext.isMaster) {
        masterComponent = component;
      }
    }

    if (formComponent) {
      this.formComponent = formComponent;

      formComponent.entityChange.subscribe((aEntity) => {
        ChangeDetectorRefHelper.detectChanges(this);
      })
    }

    if (masterComponent) {
      this.masterComponent = masterComponent;
    }
  }

  private selectEntity(entity, node?: TreeNode) {
    if (this.formComponent && this.formComponent.entity) {
      if (typeof this.formComponent.entity.responsibleGroups === 'undefined') {
        this.formComponent.entity.responsibleGroups = [];
      }
      this.formComponent.entity.responsibleGroups = [...this.formComponent.entity.responsibleGroups, entity];
    }

    if (this.masterComponent) {
      this.masterComponent.setSelectedEntity(this.formComponent.entity);

      this.entityManager.persistMore(this.masterComponent.getSelectedEntity(), [
        {property: EntityStatus.ENTITY_CHANGED_FLAG, newValue: true, force: true},
        {property: 'responsibleGroups', newValue: this.formComponent.entity.responsibleGroups, force: true}
      ]);

      ChangeDetectorRefHelper.detectChanges(this.masterComponent);
    }
  }

  private unSelectEntity(entity, node?: TreeNode) {
    if (this.formComponent && this.formComponent.entity) {
      const responsibleGroupIndex = this.formComponent.entity.responsibleGroups.findIndex((aGroup) => {
        return aGroup && entity && aGroup.id === entity.id;
      })

      this.formComponent.entity.responsibleGroups.splice(responsibleGroupIndex, 1);
    }

    if (this.masterComponent) {
      this.masterComponent.setSelectedEntity(this.formComponent.entity);

      this.entityManager.persistMore(this.masterComponent.getSelectedEntity(), [
        {property: EntityStatus.ENTITY_CHANGED_FLAG, newValue: true, force: true},
        {property: 'responsibleGroups', newValue: this.formComponent.entity.responsibleGroups, force: true}
      ]);

      ChangeDetectorRefHelper.detectChanges(this.masterComponent);
    }
  }

  public isSelected(): boolean {
    return this.entity && this.entity.id && this.formComponent && this.formComponent.entity &&
      this.formComponent.entity.responsibleGroups &&
      this.formComponent.entity.responsibleGroups instanceof Array &&
      this.formComponent.entity.responsibleGroups.findIndex((aEntity) => {
      return aEntity && aEntity.id === this.entity.id;
    }) !== -1;
  }
}
